import { useQuery } from 'react-query'

import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type RepoPaginationResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginationResponse'
import { reportAccessSecondaryCategoryQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessSecondaryCategory'
import { SecondaryCategoryConfig } from '@webapp/platform/organization-management/entities/SecondaryCategoryConfig'

type UseQueryReportAccessSecondaryCategoriesReturn = {
  secondaryCategoryConfigs: SecondaryCategoryConfig[]
  pagination?: RepoPaginationResponse
  isLoading: boolean
  isFetching: boolean
  error: unknown
}

export const useQueryReportAccessSecondaryCategories = (
  primaryCategoryId: number,
  params?: RepoFilterParams
): UseQueryReportAccessSecondaryCategoriesReturn => {
  const { data, isLoading, isFetching, error } = useQuery({
    ...reportAccessSecondaryCategoryQueryConfig.list(primaryCategoryId, params),
    // Keep the previous page rendered while refetching (overlay loader parity)
    keepPreviousData: true,
  })

  const configs = data?.data || []

  return {
    secondaryCategoryConfigs: configs.map(
      (config) => new SecondaryCategoryConfig(config)
    ),
    pagination: data?.pagination,
    isLoading,
    isFetching,
    error,
  }
}
